import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Step4Module1Operations } from '../../../../../ducks/step4Module1';
import { CustomCheckBox } from '../../../../commons/checkbox';
import { SubTitle, PlanContainer, PlanRow, PlanInfo } from '../../styles';

const PlanCurrent = React.memo(({ availablePlans }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  return (
    <>
      <SubTitle upgrade>{t('publisher.step4.module1.currentPlan.title')}</SubTitle>
      {availablePlans.map(p => {
        const planType = p.publicationPlan.publication_areas[0].publication_type;
        const name = t(`publisher.step4.module1.planName.${planType}`);
        const visibility = t(`publisher.step4.module1.${planType}.visibility`);
        const disponiblesMensaje = `Cantidad ${t('publisher.step4.module1.available.plans.number')}${
          p.available ? p.available : '1'
        }`;

        return (
          <div data-repa={`step4module1-plansArea-plan-${planType}`} key={`row-${planType}`}>
            {p.isCurrent && (
              <PlanContainer
                data-repa={`step4module1-plansArea-plan-${planType}-container`}
                isCurrentPlan={p.isCurrent && availablePlans.length > 0}
              >
                <PlanRow
                  data-repa={`step4module1-plansArea-plan-${planType}-radio-id-${p.id}`}
                  className={planType.toUpperCase()}
                  key={planType}
                  selected={p.selected}
                  plan={planType}
                  onClick={() => {
                    dispatch(Step4Module1Operations.selectAvailablePlan(p.publicationPlan.publication_plan_id));
                  }}
                >
                  <CustomCheckBox
                    isRadioButtom
                    isPlan
                    data-repa={`step4module1-plansArea-plan-${planType}-p-radio`}
                    plan={planType}
                    selected={p.selected}
                    key={`planRadio-${p.id}`}
                  >
                    <div>
                      <label
                        data-repa={`step4module1-plansArea-plan-${planType}-radio-label`}
                        htmlFor={`planRadio-${p.id}`}
                      >
                        <input
                          readOnly
                          type='radio'
                          name={`planRadio-${p.id}`}
                          value={`planRadio-${p.id}`}
                          checked={p.selected}
                          data-repa={`step4module1-plansArea-plan-${planType}-radio-input`}
                        />
                        <span data-repa={`step4module1-plansArea-plan-${planType}-radio-label-span`}>{name}</span>
                      </label>
                    </div>
                  </CustomCheckBox>
                  <PlanInfo
                    data-repa={`step4module1-plansArea-plan-${planType}-info`}
                    orden={2}
                    selected={p.selected}
                    plan={planType}
                  >
                    {visibility}
                  </PlanInfo>
                  <PlanInfo
                    data-repa={`step4module1-plansArea-plan-${planType}-info-description`}
                    orden={0}
                    selected={p.selected}
                  >
                    {disponiblesMensaje}
                  </PlanInfo>
                </PlanRow>
              </PlanContainer>
            )}
          </div>
        );
      })}
    </>
  );
});

export { PlanCurrent };
